import { render, staticRenderFns } from "./OleMissPostLab8CopperOxide.vue?vue&type=template&id=57c87535&"
import script from "./OleMissPostLab8CopperOxide.vue?vue&type=script&lang=ts&"
export * from "./OleMissPostLab8CopperOxide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VForm})
